export type WindowWithDatalayer = {
  dataLayer: {
    push: (args: datalayerObject) => void
  }
}

export type datalayerObject = {
  'event': string,
  'category': string,
  'action': string,
  'label': string
}

export const hasDatalayer = (w: any): w is WindowWithDatalayer => w['dataLayer'] != undefined

export const pushDatalayer = (d: datalayerObject) => hasDatalayer(window) ? window.dataLayer.push(d) : console.log(d)

export namespace DataLayer {
  export const showCookies = () =>
    pushDatalayer({
      event: 'noninteraction',
      category: 'cookie consent',
      action: 'cookie permission view',
      label: ''
    })
  
  export const acceptCookies = () =>
    pushDatalayer({
      event: 'interaction',
      category: 'cookie consent',
      action: 'cookie consent accepted',
      label: ''
    })
  
  export const rejectCookies = () =>
    pushDatalayer({
      event: 'interaction',
      category: 'cookie consent',
      action: 'cookie consent declined',
      label: ''
    })
  
  export const partialAcceptCookies = () =>
    pushDatalayer({
      event: 'interaction',
      category: 'cookie consent',
      action: 'cookie consent partially accepted',
      label: ''
    })
}  

